export default __webpack_public_path__ + "static/media/cert-it-hkgcsmeaa.2aa9a6ea.jpg";